const TABLETBREAK: number = 900;
const MAXWRAP: number = 1400;
const BANKNAME: string = "Maine State Credit Union";
const CONTACTLINK: string = "/about/contact";